import * as React from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import ChatClient, { ConnectionStatus } from 'fk-cp-chat';
import cx from 'classnames';
import { FileUpload } from 'components/FileUpload';
import { ChatMessageSendIcon } from 'components/Icons/Icons';
import SimpleTooltip from 'components/Tooltip/SimpleTooltip';
import StringWidget from 'components/StringWidget';
import Tooltip from 'components/Tooltip';
import AttachProductModal, { AttachProductModalType } from 'components/AttachProductModal/AttachProductModal';
import { browsedProducts } from 'utils/miscUtils';
import addIcon from 'images/chat/add-icon.svg';
import uploadImage from 'images/chat/upload-image.svg';
import cartIcon from 'images/chat/cart-icon.svg';
import wishlistIcon from 'images/chat/wishlist-icon.svg';
import recentIcon from 'images/chat/recent-icon.svg';
import { getShareProductObject } from 'utils/chatUtils';
import styles from './MessageInput.css';
class MessageInput extends React.Component {
    constructor(props) {
        super(props);
        this.setRef = e => (this.element = e);
        this.handleSendMessageClick = () => {
            const { message, isValidMessage } = this.state;
            const isDisconnected = get(this.props, 'networkStatus.connectionStatus') !== ConnectionStatus.CONNECTED;
            if (!isValidMessage || isDisconnected) {
                return;
            }
            const chatId = this.props.selectedChat;
            this.chatClient.sendMessage(chatId, message);
            this.element.innerText = '';
            this.setState({
                message: '',
                isValidMessage: false
            }, () => {
                this.props.messageSendCallback();
            });
        };
        this.handleFormSubmit = e => {
            e.preventDefault();
            this.handleSendMessageClick();
        };
        this.handleKeyPress = e => {
            const keyCode = e.which || e.keyCode;
            if (keyCode === 13) {
                e.preventDefault();
                this.handleSendMessageClick();
            }
        };
        this.handleMessageChange = e => {
            this.setState({
                message: e.target.innerText,
                isValidMessage: !!e.target.innerText.trim()
            });
            this.props.sendStartTypingStatus();
            this.props.sendStopTypingStatus();
        };
        this.toggleAttachWidgets = () => {
            this.setState(prevState => ({
                showAttachWidgets: !prevState.showAttachWidgets
            }));
        };
        this.showProducts = (type) => {
            this.context.modal.show({
                closeOnEscape: true,
                closeOnOverlayClick: true,
                closeButton: true,
                children: <AttachProductModal modalType={type} onSendProducts={this.attachProducts}/>
            });
        };
        this.attachProducts = products => {
            this.setState({
                showAttachWidgets: false
            });
            this.context.modal.hide();
            const chatId = this.props.selectedChat;
            products.map(product => this.chatClient.sendWidgetAction(chatId, getShareProductObject(product)));
            this.props.messageSendCallback();
        };
        this.state = {
            message: '',
            isValidMessage: false,
            showAttachWidgets: false
        };
        this.chatClient = ChatClient.getInstance();
    }
    componentDidMount() {
        this.element.addEventListener('paste', this.handlePaste);
    }
    componentWillUnmount() {
        this.context.modal.hide();
        this.element.removeEventListener('paste', this.handlePaste);
    }
    handlePaste(e) {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    }
    render() {
        const { showAttachWidgets, isValidMessage } = this.state;
        const isDisconnected = get(this.props, 'networkStatus.connectionStatus') !== ConnectionStatus.CONNECTED;
        const recentProducts = browsedProducts.getBrowsedPids();
        return (<div className={styles['message-input']}>
				<form className={styles['form']} onSubmit={this.handleFormSubmit}>
					<div className={styles['attach-buttons-container']}>
						<button type="button" className={cx(styles['img-wrapper'], styles['btn'])} onClick={this.toggleAttachWidgets}>
							<img src={addIcon} className={cx(styles['attach-icon'], { [styles['rotate']]: showAttachWidgets })}/>
						</button>
						<div className={cx(styles['attach-buttons'], {
            [styles['slide-up-buttons-container']]: showAttachWidgets
        })}>
							<FileUpload multiple classNames={{ button: styles['add-image-thumbnail'] }} onAddFiles={this.props.handleAddFiles}>
								<div id="upload-image" className={cx(styles['attach-button'], {
            [styles['fade-in']]: showAttachWidgets
        })}>
									<div className={styles['attach-button-img-wrapper']}>
										<img className={styles['attach-button-img']} src={uploadImage}/>
									</div>
									<SimpleTooltip anchor="#upload-image" className={styles['select-tooltip']} position="right">
										<StringWidget strKey="chatUploadImage"/>
									</SimpleTooltip>
								</div>
							</FileUpload>
							<div id="attach-from-cart" onClick={() => {
            this.showProducts(AttachProductModalType.CART);
        }} className={cx(styles['attach-button'], { [styles['fade-in']]: showAttachWidgets })}>
								<div className={styles['attach-button-img-wrapper']}>
									<img className={styles['attach-button-img']} src={cartIcon}/>
								</div>

								<SimpleTooltip anchor="#attach-from-cart" className={styles['select-tooltip']} position="right">
									<StringWidget strKey="chatAttachItemFrom" attributes={{ from: 'Cart' }}/>
								</SimpleTooltip>
							</div>
							<div id="attach-from-wishlist" onClick={() => {
            this.showProducts(AttachProductModalType.WISHLIST);
        }} className={cx(styles['attach-button'], { [styles['fade-in']]: showAttachWidgets })}>
								<div className={styles['attach-button-img-wrapper']}>
									<img className={styles['attach-button-img']} src={wishlistIcon}/>
								</div>
								<SimpleTooltip anchor="#attach-from-wishlist" className={styles['select-tooltip']} position="right">
									<StringWidget strKey="chatAttachItemFrom" attributes={{ from: 'Wishlist' }}/>
								</SimpleTooltip>
							</div>
							{recentProducts && recentProducts.length !== 0 && (<div id="attach-from-recent" onClick={() => {
            this.showProducts(AttachProductModalType.RECENT);
        }} className={cx(styles['attach-button'], { [styles['fade-in']]: showAttachWidgets })}>
									<div className={styles['attach-button-img-wrapper']}>
										<img className={styles['attach-button-img']} src={recentIcon}/>
									</div>
									<SimpleTooltip anchor="#attach-from-recent" className={styles['select-tooltip']} position="right">
										<StringWidget strKey="chatAttachItemFrom" attributes={{ from: 'Recently Viewed' }}/>
									</SimpleTooltip>
								</div>)}
						</div>
					</div>
					{!this.state.message && <div className={styles['input-placeholder']}>Type a Message...</div>}
					<div ref={this.setRef} className={styles['input']} contentEditable onInput={this.handleMessageChange} onKeyPress={this.handleKeyPress}/>
					<button className={cx(styles['img-wrapper'], styles['btn'])} type="submit" id="chat-send-icon-btn">
						{ChatMessageSendIcon({ fill: isDisconnected || !isValidMessage ? '#cccccc' : '#2874F0' })}
					</button>
					{isDisconnected && (<Tooltip auto={false} active={true} anchor={`#chat-send-icon-btn`} position="top-right" className={styles['send-btn-tooltip-text']}>
							<StringWidget strKey="chatSendNetworkErrorMsg"/>
						</Tooltip>)}
				</form>
			</div>);
    }
}
MessageInput.contextTypes = {
    modal: PropTypes.object
};
export default MessageInput;
